import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handleSqsMessageBatchSizeChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { genericS3ThrottleEnabled, overrideSource, sqsMessageBatchSize } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleSqsBatchSizeChange = (e) => {
    const { value } = e.target;
    onChange(e, formData);
    if (value >= 1 && value <= 10) {
      handleSqsMessageBatchSizeChange("");
    } else {
      handleSqsMessageBatchSizeChange("Please select SQS Message Batch Size between 1 - 10.");
    }
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "genericS3ThrottleEnabled",
      defaultChecked: genericS3ThrottleEnabled == null ? void 0 : genericS3ThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "overrideSource",
      type: "text",
      value: overrideSource == null ? void 0 : overrideSource.value,
      onChange,
      label: "Override Source (optional)",
      help: "The source is set to the S3 bucket name by default. Set this if you want to override it with a custom value."
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "sqsMessageBatchSize",
      type: "number",
      min: "1",
      value: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
      onChange: internalHandleSqsBatchSizeChange,
      label: "SQS Message Batch Size",
      help: "The maximum number of messages to query from SQS at a time. The maximum acceptable value is 10."
    }
  ));
};
export default FormAdvancedOptions;
